<template>
	<div class="advert-manage-container">
		<!-- 数据卡片 -->
		<InfoCards :data="assetStats" />

		<!-- 搜索条件 -->
		<QueryCard @search="handleSearch" @reset="handleReset">
			<template slot="base">
				<el-col :span="6">
					<el-input v-model="query.planNo" placeholder="请输入规划编号" />
				</el-col>
				<el-col :span="6">
					<el-input v-model="query.assetNoOrName" placeholder="请输入资产编号/名称" />
				</el-col>
				<el-col :span="6">
					<el-select v-model="query.planType" placeholder="请选择规划类型" style="width: 100%">
						<el-option
							v-for="(item, index) in $menu.getList('PlanningType')"
							:key="index"
							:label="item.name"
							:value="item.value" />
					</el-select>
				</el-col>
			</template>
			<template slot="more">
				<el-col :span="6">
					<el-select v-model="query.status" placeholder="请选择规划状态" style="width: 100%">
						<el-option
							v-for="(item, index) in $menu.getList('AssetPlanStatus')"
							:key="index"
							:label="item.name"
							:value="item.value" />
					</el-select>
				</el-col>
				<el-col :span="6">
					<el-select v-model="query.department" placeholder="请选择责任部门" style="width: 100%">
						<el-option v-for="item in OrgTree" :key="item.id" :label="item.text" :value="item.id" />
					</el-select>
				</el-col>
			</template>
		</QueryCard>

		<!-- 表格 -->
		<BaseTable
			:actions="{
				add: true,
				export: true,
				operation: true,
			}"
			:loading="loading"
			:exportLoading="exportLoading"
			:data="tableData"
			:columns="columns"
			:total="total"
			:pageNum="query.pageNum"
			:pageSize="query.pageSize"
			@page-change="pageChange"
			@size-change="sizeChange"
			@add="handleAdd"
			@export="handleExport">
			<template #assetCategory="{ row }">
				{{ $menu.getLabel('AssetCategory', row.assetCategory) }}
			</template>
			<template #planType="{ row }">
				<el-tag :type="PlanningType[row.planType] || 'default'" size="small">
					{{ $menu.getLabel('PlanningType', row.planType) || '-' }}
				</el-tag>
			</template>
			<template #progress="{ row }">
				<el-progress
					style="width: 100%"
					:percentage="row.progress"
					:status="row.progress == 100 ? 'success' : null"
					:text-color="row.progress == 100 ? '#67c23a' : '#333'"></el-progress>
			</template>
			<template #status="{ row }">
				<el-tag :type="AssetPlanStatus[row.status] || 'default'" size="small">
					{{ $menu.getLabel('AssetPlanStatus', row.status) || '-' }}
				</el-tag>
			</template>
			<template #operation="{ row }">
				<el-button type="text" @click="handleShow(row)">查看</el-button>
				<el-button type="text" @click="handleEdit(row)">编辑</el-button>
				<el-button type="text" @click="handleUpdate(row)">更新进度</el-button>
			</template>
		</BaseTable>

		<AssetPlanDialog
			:dialogVisible.sync="dialogVisible"
			:isEdit="isEdit"
			:data="currentRow"
			@updateSuccess="updateSuccess" />
		<AssetPlanProgressDialog
			:dialogVisible.sync="progressDialogVisible"
			:data="currentRow"
			@updateSuccess="updateSuccess" />
		<AssetPlanDrawer :dialogVisible.sync="drawerVisible" :data="currentRow" />
	</div>
</template>

<script>
	import { PlanningType, AssetPlanStatus } from '@/utils/meunType.js';
	import AssetPlanDialog from '@/components/asset/assetPlanDialog';
	import AssetPlanProgressDialog from '@/components/asset/assetPlanProgressDialog';
	import AssetPlanDrawer from '@/components/asset/assetPlanDrawer';
	import { getAssetPlanPage, getAssetPlanStatistics, exportAssetPlanList } from '@/api/asset/assetPlanApi.js';
	import { listOrgTree } from '@/api/inspection/addMaintainancePlanApi.js';
	import { getCommunityId } from '@/utils/vc.js';
	export default {
		name: 'AssetPlan',
		components: { AssetPlanDialog, AssetPlanProgressDialog, AssetPlanDrawer },
		data() {
			return {
				AssetPlanStatus,
				PlanningType,
				OrgTree: [],
				assetStats: [
					{ label: '总规划数', value: 0, unit: '个', color: '#5B8FF9', key: 'totalCount' },
					{ label: '非经他用', value: 0, unit: '个', color: '#61DDAA', key: 'nonEconomicUseCount' },
					{ label: '租赁经营', value: 0, unit: '个', color: '#65789B', key: 'leaseOperationCount' },
					{ label: '销售去化', value: 0, unit: '个', color: '#F6BD16', key: 'salesDisposalCount' },
					{ label: '进行中', value: 0, unit: '个', color: '#7262FD', key: 'updateRenovationCount' },
					{
						label: '闲置资产规划覆盖率',
						value: 0,
						unit: '%',
						color: '#78D3F8',
						info: true,
						content: '闲置资产规划覆盖率=闲置资产规划数量/闲置资产数量× 100%',
						key: 'planRate',
					},
				],
				total: 0,
				query: {
					planNo: '',
					assetNoOrName: '',
					communityId: getCommunityId(),
					planType: '',
					status: '',
					department: '',
					pageNum: 1,
					pageSize: 10,
				},
				tableData: [],
				columns: [
					{ prop: 'planNo', label: '规划编号', width: '160px' },
					{ prop: 'assetNo', label: '资产编号', width: '160px' },
					{ prop: 'assetName', label: '资产名称', width: '180px' },
					{ prop: 'communityName', label: '所属项目' },
					{ prop: 'assetCategory', label: '规划前资产类型', width: '130px', slot: 'assetCategory' },
					{ prop: 'planType', label: '规划类型', slot: 'planType' },
					{ prop: 'startDate', label: '开始日期' },
					{ prop: 'endDate', label: '结束日期' },
					{ prop: 'progress', label: '进度', slot: 'progress', width: '150px', align: 'left' },
					{ prop: 'department', label: '责任部门' },
					{ prop: 'responsiblePerson', label: '责任人' },
					{ prop: 'status', label: '状态', slot: 'status' },
				],
				loading: false,
				exportLoading: false,
				currentRow: {},
				dialogVisible: false,
				isEdit: false,
				progressDialogVisible: false,
				drawerVisible: false,
			};
		},
		created() {
			this.fetchAssetPlanStatistics();
			this.getTreelist();
			this.getList();
		},
		methods: {
			async getTreelist() {
				const res = await listOrgTree();
				this.OrgTree = res.data.children || [];
			},
			async fetchAssetPlanStatistics() {
				try {
					const res = await getAssetPlanStatistics({ communityId: getCommunityId() });
					this.assetStats = this.assetStats.map(item => ({
						...item,
						value: res[item.key] || 0,
					}));
				} catch (err) {
					console.log(err);
				}
			},

			async getList() {
				try {
					this.loading = true;
					const res = await getAssetPlanPage(this.query);
					this.tableData = res.records;
					this.total = Number(res.total);
				} catch (error) {
					console.log(error);
				} finally {
					this.loading = false;
				}
			},
			handleSearch() {
        this.query.pageNum = 1;
				this.getList();
			},
			pageChange(page) {
				this.query.pageNum = page;
				this.getList();
			},
			sizeChange(size) {
				this.query.pageSize = size;
				this.getList();
			},
			handleReset() {
				this.query = {
					planNo: '',
					assetNoOrName: '',
					communityId: getCommunityId(),
					planType: '',
					status: '',
					department: '',
					pageNum: 1,
					pageSize: 10,
				};
				this.getList();
			},
			handleAdd() {
				this.isEdit = false;
				this.currentRow = {};
				this.dialogVisible = true;
			},
			handleEdit(row) {
				this.isEdit = true;
				this.currentRow = row;
				this.dialogVisible = true;
			},
			handleExport() {
				if (this.exportLoading) return;
				const params = {
					pageNum: this.query.pageNum,
					pageSize: this.query.pageSize,
					communityId: this.query.communityId,
					assetNoOrName: this.query.assetNoOrName,
					department: this.query.department,
					planType: this.query.planType,
					status: this.query.status,
				};
				this.exportLoading = true;
				exportAssetPlanList(params)
					.then(response => {
						const blob = new Blob([response.data]);
						let fileName = '资产规划列表.xlsx';
						const disposition = response.headers && response.headers['content-disposition'];
						if (disposition) {
							const utfMatch = disposition.match(/filename\*=UTF-8''([^;]+)/i);
							const normalMatch = disposition.match(/filename="?([^";]+)"?/i);
							const raw = utfMatch ? utfMatch[1] : (normalMatch ? normalMatch[1] : '');
							if (raw) {
								fileName = decodeURIComponent(raw);
							}
						}
						const url = window.URL.createObjectURL(blob);
						const link = document.createElement('a');
						link.style.display = 'none';
						link.href = url;
						link.setAttribute('download', fileName);
						document.body.appendChild(link);
						link.click();
						document.body.removeChild(link);
						window.URL.revokeObjectURL(url);
						this.$message.success('导出成功');
					})
					.catch(err => {
						console.log(err);
						this.$message.error('导出失败');
					})
					.finally(() => {
						this.exportLoading = false;
					});
			},
			handleShow(row) {
				this.drawerVisible = true;
				this.currentRow = row;
			},
			handleUpdate(row) {
				this.currentRow = row;
				this.progressDialogVisible = true;
			},
			updateSuccess() {
				this.query.pageNum = 1;
				this.query.pageSize = 10;
				this.getList();
			},
		},
	};
</script>

<style lang="scss" scoped>
	.advert-manage-container {
		padding: 20px;
		color: #1c1c1c;
		text-align: left;
	}
</style>
